module.exports = __webpack_public_path__ + "static/img/icon_js_machine.1449ca24.png";